import { render, staticRenderFns } from "./BaseImg.vue?vue&type=template&id=3cc09e42&"
import script from "./BaseImg.vue?vue&type=script&lang=js&"
export * from "./BaseImg.vue?vue&type=script&lang=js&"
import style0 from "./BaseImg.vue?vue&type=style&index=0&id=3cc09e42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports